export default "__VITE_ASSET__BE445sQk__"